import React, { useState, useEffect} from "react";
import './App.css';
import VideoCard from "./VideoCard";
import db from "./firebase";
// import VideoHeader from "./VideoHeader";

function App() {

  const [reels, setReels] = useState([]);
  useEffect(() => {
    //App component will run Once it loads and never again
    db.collection('reels').onSnapshot(snapshot => (
      setReels(snapshot.docs.map(doc => doc.data()))
      
    ))
  }, [])

  // useEffect(() => {
  //   //App component will run Once it loads and never again
  //   console.log(reels);
      
  
  // }, [reels])
  return (
    
    //BEM Naming Convention: In this the class Name is in lower case and further more things also
    <div className="app">
      {/* <h1>Let's Build an IG Reels Clone 😎.</h1> */}

      {/* To make the App */}

      {/* 1st div tag contains: */}
      <div className="app__top">
      {/* Ig Image will be at the top */}
      <img className="app__logo" 
      src="https://www.computerhope.com/jargon/i/instagram.png" 
      alt="IG-Logo"   
      />

      <h1>Reels</h1>
      {/* Reels text */}
      </div>


      {/* 2nd div tag contains: */}
      <div className="app__videos">
      
      {reels.map (({channel, avatarSrc, song, url, likes, shares}) => (
      <VideoCard 
        channel={channel}
        avatarSrc={avatarSrc}
        song={song}
        url={url}
        likes={likes}
        shares={shares}
      />
      ))}
      
      
      {/* Scrollable container of videos */}
      </div>
    </div>
  );
}

export default App;
